import script from "./ServiceDetailsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceDetailsSection.vue?vue&type=script&setup=true&lang=js"

import "./ServiceDetailsSection.vue?vue&type=style&index=0&id=284ca35a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-284ca35a"]])

export default __exports__